import React, { useEffect } from 'react'
import { useField, useFormikContext } from 'formik'

interface SetValueProps extends React.HTMLProps<HTMLInputElement> {
    name: string
    value: string
}
const SetValue: React.FC<SetValueProps> = ({ name, value, ...props }) => {
    const [field] = useField(name)
    const { setFieldValue } = useFormikContext()

    useEffect(() => {
        setFieldValue(field.name as never, value)
    }, [value])

    return <input style={{ display: 'none' }} {...field} {...props} />
}
export default SetValue
